export class InvoiceAdjustmentToGSearchResults {
    public constructor(init?: Partial<InvoiceAdjustmentToGSearchResults>) {
      Object.assign(this, init);
    }
      invoiceNumber: string;
      AmountOfChange: number;
      lotNumber: string;
   }